import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { ILabProjectStatusType } from "./routeType";

const { key, getPath } = getApi("types.labProject.getAll");

type IExtractedRouteType =
  ILabProjectStatusType["LabProjectStatusTypeCollectionRetrieve"];

export type IGetLabProjectStatusType =
  IPickCollectionQuery<IExtractedRouteType>;

const getLabProjectStatusType: Fetcher<
  IGetLabProjectStatusType["response"],
  IGetLabProjectStatusType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetLabProjectStatusType = createQuery({
  queryKey: [key],
  fetcher: getLabProjectStatusType,
});
